import { createContext, useContext, useEffect, useRef } from 'react';

export const AdvancedCobrandingContext = createContext<
  | undefined
  | {
      components?: Array<string>;
      registerComponent: (component: string) => void;
    }
>(undefined);

export const useAdvancedCobrandingContext = () => {
  const context = useContext(AdvancedCobrandingContext);

  if (!context) {
    throw new Error('useAdvancedCobrandingContext used outside of AdvancedCobrandingContext');
  }

  return context;
};

export const useRegisterComponent = (name: string) => {
  const registered = useRef(false);
  const context = useContext(AdvancedCobrandingContext);

  useEffect(() => {
    if (registered.current) return;
    if (!context) return;

    registered.current = true;
    context.registerComponent(name);
  }, [context, name]);
};
